import { render, staticRenderFns } from "./FeaturedProperty.vue?vue&type=template&id=65f3547b&scoped=true&"
import script from "./FeaturedProperty.vue?vue&type=script&lang=js&"
export * from "./FeaturedProperty.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedProperty.vue?vue&type=style&index=0&id=65f3547b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f3547b",
  null
  
)

export default component.exports